import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { IrfeProjeto } from '../../models/irfe-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IrfeProjetoService } from '../../services/irfe-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-irfe-list',
  templateUrl: './detalhe-irfe-list.component.html',
  styleUrls: ['./detalhe-irfe-list.component.css']
})
export class DetalheIrfeListComponent extends BaseListComponent<IrfeProjeto> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  permission: any;
  irfeList: IrfeProjeto[];

  constructor(
    private myService: IrfeProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initLoadDataTable();
    });
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.irfeList = res['irfes'];
        this.permission = res['permission'];
        this.loaded();
      })
    );
  }

  initDataTable() {
    this.initLoadDataTable();
    this.dtOptions1 = {
      language: this._language,
      dtTrigger: new Subject<any>(),
      columns: [
        {
          title: 'Objeto',
          data: 'ds_object',
        },
        {
          title: 'Status Operacional',
          data: 'operational_status_label',
        },
        {
          title: 'Data de término da vigência',
          data: 'dt_end',
        },
        {
          title: 'Valor de repasse',
          data: 'transfer_value',
        },
        {
          title: 'Valor de contrapartida',
          data: 'counterpart_value',
        },
        {
          title: 'Ações',
          data: null,
          render: function (data, type, row, meta) {
            let ret = '';
            let tx_edit = 'Ver'
            if (data.canSave) {
              tx_edit = 'Editar'
              ret += '<button class="btn-danger btn btn-xs btn-delete m-r-xs">Excluir</button>';
            }
            ret += '<button class="btn-white btn btn-xs btn-update">' + tx_edit + '</button>';
            return ret;

          },
        },
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        $('.btn-update', row).off('click');
        $('.btn-update', row).on('click', () => {

        });
        $('.btn-delete', row).off('click');
        $('.btn-delete', row).on('click', () => {
          this.alertConfirmation(data).subscribe((confirmed) => {
            if (confirmed) {
            }
          });
        });
        return row;
      },
    };
  }
}
